import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface ReimbursementCategoriesTypeValues {
  restrictedExpenseCategories: any[]
  planPeriodId?: string
}

export const getAvailableReimbursementCategories = (): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/BenefitDesign/RestrictableReimbursementCategories`)
}

export const saveRestrictedReimbursementCategories = (values: ReimbursementCategoriesTypeValues): Promise<any> => {
  return adminHttpClient.put(`/AdminDashboard/BenefitDesign/RestrictReimbursementCategories`, values)
}
